import { Lightning } from '@lightningjs/sdk';
import Icon from '../../../../tornado/icon/icon.component';
import { ICON_TYPE } from '../../../../tornado/icon/icon.constants';
import { getScreenSize } from '../../../../tornado/utils/sizes';
import connect from './sidenavLogo.connect';
import { getLogoViewBox } from '../../sidenavLogo.utils';
import { LOGO_ICON_SCALE, MAX_INDEX, MIN_INDEX, UPDATE_TIMEOUT_MS } from './sidenavLogo.constants';

export class SidenavLogo extends Lightning.Component {
  static _template() {
    return {
      Icon: {
        type: Icon,
      },
    };
  }

  _construct() {
    this._style = { screenSize: getScreenSize() };
  }

  _attach() {
    this._unsubscribe = connect(this);

    this.tag('Icon').on('txLoaded', () => {
      const icon = this.tag('Icon');
      this.patch({ w: icon.finalW, h: icon.finalH });
    });
  }

  _detach() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }
    clearTimeout(this._logoUpdateTimeout);
    this.tag('Icon').removeAllListeners('txLoaded');
  }

  updateLogo() {
    this._logoUpdateTimeout = setTimeout(() => {
      this.tag('Icon').iconData = {
        picto: {
          type: ICON_TYPE.SERVICE_ICON,
          name: `rtlplus_root_alternate_${MIN_INDEX + Math.floor(Math.random() * MAX_INDEX)}`,
        },
        scale: LOGO_ICON_SCALE,
        viewBox: getLogoViewBox(this._style.screenSize),
      };
    }, UPDATE_TIMEOUT_MS);
  }
}
